import React, { useEffect, useRef, useState } from "react";
import ProduceMarket from "./ProduceMarket";
import { useDispatch, useSelector } from "react-redux";
import { formatText } from "../../../../utils";
import BreadCrumb from "../../../../layout/BreadCrumb";
import { Form, Select } from "antd";
import { fetchData, fetchPeriods } from "../../../../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";
import SchemeCropsTable from "../crops-dynamic-table/SchemeCropsTable";

function CropProduceCommList() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeObjSchemes, periods } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["communitySchemes"],
    periods: state.fetch.periods,
  }));

  const [periodId, setPeriodId] = useState(
    periods?.length > 0 ? periods?.[0]?.proId : null
  );

  useEffect(() => {
    dispatch(fetchPeriods({ proSchId: activeObjSchemes?.schId }));
  }, []);

  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Scheme View", path: "/scheme/public-scheme-view" },
          { title: "Crop Produce & Market" },
        ]}
      />
      <div className="white_card mt-[1.25rem]">
        <div className="form-add-h">{activeObjSchemes?.schName}</div>
        <div className="mt-[.62rem] gap-x-[.62rem] text-[.875rem] font-[400] text-[rgba(0,0,0,0.60)] flex items-center">
          <span>{formatText(activeObjSchemes?.schSchemeType)}</span>
          <span>•</span>
          <span>{activeObjSchemes?.schCountyName}</span>
          <span
            className="gap-[.625rem] flex items-center 
                justify-center rounded-[.5rem] bg-[#E5E8E9] px-[.25rem] py-[.125rem] max-w-[6.875rem] text-[#393939] font-interSans text-[0.625rem]"
          >
            Survey
          </span>
        </div>
        <div className="custom-title mt-[2.5rem] mb-[2.5rem]">
          {" "}
          Update Crop Production Data
        </div>

        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="w-full lg:w-[40%]"
          form={form}
        >
          <Form.Item
            label={"Select Year"}
            rules={[
              {
                required: true,
                message: "Please select year",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                periods?.length > 0 &&
                periods?.map((item) => ({
                  value: item?.proId,
                  label: item?.proPeriod,
                }))
              }
              value={periodId}
              onChange={(value) => setPeriodId(value)}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
        </Form>
        <ProduceMarket periodId={periodId} />

        <div className="graph_h1 !text-[#1A1A1A] ">Crop Production Data</div>
        <SchemeCropsTable periodId={periodId} />
      </div>
    </>
  );
}

export default CropProduceCommList;
